import { styled } from '@clickcease/cc-client-components-lib'

export const EditDomainProductsModalStyled = styled('div', {
  width: '450px',
  fontFamily: 'Open Sans',
})

export const EditDomainProductsModalWrapper = styled('div', {
  fontSize: '$md',
})

export const BotMitigationRow = styled(EditDomainProductsModalWrapper, {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
})

export const EditDomainProductsModalDescription = styled('div', {
  fontWeight: '$l',
})

export const EditDomainProductsModalDomain = styled('div', {
  fontWeight: '$sb',
})

export const EditDomainProductsModalProductOption = styled('div', {
  display: 'flex',
  marginTop: '$8',

  ['> button']: {
    marginRight: '$4',
    marginTop: '$1',
  },
})
